// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"fa64e991","792":"a82e00a8"}[chunkId] + ".chunk.js";
};